/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelSummary } from './HotelSummary';
import {
    HotelSummaryFromJSON,
    HotelSummaryFromJSONTyped,
    HotelSummaryToJSON,
    HotelSummaryToJSONTyped,
} from './HotelSummary';

/**
 * A single completed batch's hotel results. One event fires per
 * completed batch, in arrival order (not necessarily by batch_num).
 * 
 * @export
 * @interface SearchStreamHotels
 */
export interface SearchStreamHotels {
    /**
     * 
     * @type {string}
     * @memberof SearchStreamHotels
     */
    type: SearchStreamHotelsTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SearchStreamHotels
     */
    batchNum: number;
    /**
     * 
     * @type {Array<HotelSummary>}
     * @memberof SearchStreamHotels
     */
    items: Array<HotelSummary>;
}


/**
 * @export
 */
export const SearchStreamHotelsTypeEnum = {
    Hotels: 'hotels'
} as const;
export type SearchStreamHotelsTypeEnum = typeof SearchStreamHotelsTypeEnum[keyof typeof SearchStreamHotelsTypeEnum];


/**
 * Check if a given object implements the SearchStreamHotels interface.
 */
export function instanceOfSearchStreamHotels(value: object): value is SearchStreamHotels {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('batchNum' in value) || value['batchNum'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function SearchStreamHotelsFromJSON(json: any): SearchStreamHotels {
    return SearchStreamHotelsFromJSONTyped(json, false);
}

export function SearchStreamHotelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchStreamHotels {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'batchNum': json['batch_num'],
        'items': ((json['items'] as Array<any>).map(HotelSummaryFromJSON)),
    };
}

export function SearchStreamHotelsToJSON(json: any): SearchStreamHotels {
    return SearchStreamHotelsToJSONTyped(json, false);
}

export function SearchStreamHotelsToJSONTyped(value?: SearchStreamHotels | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'batch_num': value['batchNum'],
        'items': ((value['items'] as Array<any>).map(HotelSummaryToJSON)),
    };
}

